import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import {
  et3ParseInteger,
  getOnlyDigitsFromString,
  isPositiveNumber
} from "et3-type-guards";
import { runInAction } from "mobx";
import i18n from "../../../constants/i18n";
import { MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED } from "../../../constants/input-entries-constants";
import { USER_SEARCH_FORM_LIMIT } from "../../../constants/picker-entries-constants";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import getUserStore from "../../../stores/user-store";
import getUserEventsStore from "../../../stores/user-store/events-store";
import FilterSelect from "../../khattabat/matching/search-and-101m/form/FilterSelect";

const KhattabatUserEventsForm = withLiteObserverAndTheme(() => {
  const { userIdInput, selectedLimitInput } = getUserStore();
  const userID = userIdInput.get();

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        flexWrap="wrap"
        useFlexGap
      >
        <TextField
          size="small"
          label={i18n.get("USER_ID")}
          value={isPositiveNumber(userID) ? `${userID}` : ""}
          onChange={({ target }) => {
            const parsedStringValue = getOnlyDigitsFromString(target.value);
            if (
              parsedStringValue.length < MAXIMUM_PHONE_NUMBER_DIGITS_ALLOWED
            ) {
              const parsedIntegerValue = et3ParseInteger(parsedStringValue);
              runInAction(() => userIdInput.set(parsedIntegerValue));
            }
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" && isPositiveNumber(userID)) {
              getUserEventsStore().getUserEvents();
            }
          }}
          slotProps={{ htmlInput: { inputMode: "numeric" } }}
          sx={{ minWidth: 200 }}
        />
        <Stack sx={{ minWidth: 160 }}>
          <FilterSelect
            label={i18n.get("LIMIT")}
            options={USER_SEARCH_FORM_LIMIT}
            value={selectedLimitInput.get()}
            onChange={(value) =>
              runInAction(() => selectedLimitInput.set(value))
            }
          />
        </Stack>
        <Button
          variant="contained"
          disabled={!isPositiveNumber(userID)}
          onClick={getUserEventsStore().searchUserEvents}
          sx={{ ml: "auto", whiteSpace: "nowrap" }}
        >
          {i18n.get("GET")}
        </Button>
      </Stack>
    </Paper>
  );
});

export default KhattabatUserEventsForm;
